import { Component, input, OnInit, output } from '@angular/core';

import { DashboardService } from '../../dashboard-service/dashboard.service';

import { catchError, throwError } from 'rxjs';
import { TDashlet, TDashletSiteRange } from 'src/app/project/modules/preferences/preferences.model';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventDashboard,
  EGoogleEventFleetManagement,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { AssetDashboardService } from '../../../fleet-management/fleet-management-fleet-page/fleet-assets/asset-card/asset-dashboard/asset-dashboard.service';
import { EDashletPeriod } from '../../dashboard-timeframes-enums';
import { EDashletType } from '../../dashlets-enums';

@Component({
  selector: 'pp-dashlet-flip',
  templateUrl: './dashlet-flip.component.html',
  styleUrls: ['./dashlet-flip.component.scss'],
  standalone: false,
})
export class DashletFlipComponent implements OnInit {
  ppDashlet = input<TDashlet>(undefined);
  ppAssetId = input<string>(undefined);
  ppFlipped = input<boolean>(undefined);
  ppDefaultWorkspaces = input<string[]>(undefined);
  ppToggleFlip = output<void>();
  ppSelectPeriod = output<EDashletPeriod>();
  ppSelectSiteRange = output<TDashletSiteRange>();
  ppDashletNameChange = output<string>();

  dashletTypes = EDashletType;
  period: EDashletPeriod;
  siteRange: TDashletSiteRange;
  dashletName: string;
  private isDeleting = false;

  constructor(
    private dashboardService: DashboardService,
    private assetDashboardService: AssetDashboardService,
  ) {}

  ngOnInit() {
    this.period = this.ppDashlet().period;
    this.dashletName = this.ppDashlet().customName;

    this.siteRange = {
      workspaceIds: this.ppDashlet().selectedRange.workspaceIds,
      accountId: this.ppDashlet().selectedRange.accountId,
    };
  }

  onDashletNameChange(updatedDashlet: TDashlet): void {
    this.dashletName = updatedDashlet.customName;
  }

  updatePeriod(data: EDashletPeriod): EDashletPeriod {
    this.period = data;

    return this.period;
  }

  removeDashlet(): void {
    if (this.isDeleting) {
      return;
    }

    this.isDeleting = true;

    if (this.ppAssetId()) {
      logEventInGTAG(EGoogleEventFleetManagement.ASSET_DASHLET_REMOVE, {
        source: EGoogleEventCategory.FLEET_MANAGEMENT,
        type: this.ppDashlet().name,
      });

      this.assetDashboardService
        .removeDashlet(this.ppAssetId(), this.ppDashlet())
        .pipe(
          catchError((error) => {
            this.isDeleting = false;

            return throwError(() => error);
          }),
        )
        .subscribe();
    }

    logEventInGTAG(EGoogleEventDashboard.DASHBOARD__DASHLET__DELETE, {
      source: EGoogleEventCategory.DASHBOARD,
      type: this.ppDashlet().name,
    });

    this.dashboardService.removeDashlet(this.ppDashlet());
  }

  apply(): void {
    if (this.period !== this.ppDashlet().period) {
      this.ppSelectPeriod.emit(this.period);
    }

    if (
      this.siteRange.workspaceIds !== this.ppDashlet().selectedRange.workspaceIds ||
      this.siteRange.accountId !== this.ppDashlet().selectedRange.accountId
    ) {
      this.ppSelectSiteRange.emit(this.siteRange);
    }

    if (this.dashletName !== this.ppDashlet().customName) {
      this.ppDashletNameChange.emit(this.dashletName);
    }

    this.ppToggleFlip.emit();
  }

  flipDashlet(): void {
    this.period = this.ppDashlet().period;
    this.dashletName = this.ppDashlet().customName;

    this.siteRange = {
      workspaceIds: this.ppDashlet().selectedRange.workspaceIds,
      accountId: this.ppDashlet().selectedRange.accountId,
    };

    this.ppToggleFlip.emit();
  }
}
